import styled from 'styled-components';

export default styled.div`
	padding-bottom: 150px;
	#add-transaction {
		width: 50px;
		height: 50px;
		position: fixed;
		bottom: 100px;
		right: 20px;
		border-radius: 10rem;
		background: #f54949;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.transactions-list {
		padding: 20px;
	}
	.loadmore-button {
		margin: 0 auto;
		display: inherit;
		padding: 10px 20px;
		border: 0;
		border-radius: 10rem;
		margin-top: 50px;
		background: #222;
		color: #555;
		div {
			padding: 0;
			height: 19px;
		}
	}
`;
